module.exports = __webpack_public_path__ + "img/profilePic.280ceef5.jpg";